export default __webpack_public_path__ + "static/media/lovingkindness-short.b7d67f79.m4a";